import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AdminProbate } from '../models/admin-probate.model';
import { PaginatedResponse } from '@core/models/paginated-response.model';
import { AdminSubscriber } from '../models/admin-subscriber.model';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { CourtService } from '@shared/services/court.service';
import { FilterParams } from '../models/filter-params.model';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import {
  SearchRegisteredUser,
  SearchRegisteredUserQueryParams,
} from '../models/clerk-probate-http.models';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private http = inject(HttpClient);
  private courtService = inject(CourtService);

  getProbates(
    filters: FilterParams,
  ): Observable<PaginatedResponse<AdminProbate>> {
    const params = this.createHttpParams(filters);
    return this.http.get<PaginatedResponse<AdminProbate>>(
      `${environment.api}/courts/${this.courtService.courtId()}/probates/`,
      { params },
    );
  }

  getSubscribers(
    filters: FilterParams,
  ): Observable<PaginatedResponse<AdminSubscriber>> {
    const params = this.createHttpParams(filters);
    return this.http.get<PaginatedResponse<AdminSubscriber>>(
      `${environment.api}/courts/${this.courtService.courtId()}/subscribers/`,
      { params },
    );
  }

  private createHttpParams(filters: FilterParams): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value.toString());
      }
    });
    return params;
  }

  public getRegisteredUsers(
    params: SearchRegisteredUserQueryParams,
  ): Observable<SearchRegisteredUser[]> {
    return this.http
      .get<SearchRegisteredUser[]>(
        `${environment.api}/courts/${this.courtService.courtId()}/users/`,
        {
          params: objectToSnake(params),
        },
      )
      .pipe(map((response) => objectToCamel(response)));
  }
}
